import settings from 'settings'
const { workspaceApiUrl } = settings
import { getRequest } from '../api/requests'

export async function getWatchToken(): Promise<string> {
  const response = await getRequest(`${workspaceApiUrl}/watch/token`)
  return response.token
}
